export const CommonConstant = {
    EMPTY_STRING: '',
    EVALUATE: 'Evaluate',
    INCOMPLETE_APP: 'Incomplete App',
    APPROVE: 'Approve',
    REJECT: 'Reject',
    COMMENTS: 'Comments',
    GDPR: 'GDPR',
};

export const CommonApiFunctions = {
    COMMON_FUNCTION: 'commonFunction',
    SEARCH_DOMAINS: 'searchDomains',
    DOMAIN_CHANGES: 'domainChangeReq',
    GET_DOMAIN_BY_ID: 'getDomainById',
    APP_DOMAIN_CHANGE: 'appDomainEntryChange',
    ML_SCORE: 'mlScore',
};

export const PaginationConstant = {
    pageSizeOptions: ['10', '20', '30', '50', '100'],
    defaultPageSize: '20',
    showSizeChanger: true,
};

export const ModalTitles = {
    SEARCH_SAAS_MODAL_TITLE: '',
};

export const CloudIcons = {
    excellent: {
        label: 'Excellent',
        value: 'excellent',
        color: '#70A965', // 100 - 90
        tooltipMsg: 'Excellent Score: 90 to 100',
        minValue: 90,
    },
    high: {
        label: 'High',
        value: 'high',
        color: '#8ED081', // 75 - 89
        tooltipMsg: 'High Score: 75 to 89',
        minValue: 75,
    },
    medium: {
        label: 'Medium',
        value: 'medium',
        color: '#FFD100', // 60 - 74
        tooltipMsg: 'Medium Score: 60 to 74',
        minValue: 60,
    },
    low: {
        label: 'Low',
        value: 'low',
        color: '#FF8300', // 50 - 59
        tooltipMsg: 'Low Score: 50 to 59',
        minValue: 50,
    },
    poor: {
        label: 'Poor',
        value: 'poor',
        color: '#FF5050', // 0 - 49
        tooltipMsg: 'Poor Score: 0 to 49',
        minValue: 0,
    },
    unknown: {
        label: 'Unknown',
        value: 'unknown',
        color: '#9B9B9B',
        tooltipMsg: 'Discovery Only',
    },
};

export const UiURLs = {
    RESEARCH_UI: '/cciresearch/',
};

export const ErrorMsg = {
    VALIDATION_FAILED: 'Validation Failed',
    GET_APP_FAILED: 'Failed to get application data',
};

export const StringSeparator = {
    COMMA: ',',
    COMMA_SPACE: ', ',
    NEW_LINE: '\n',
    COLON: ':',
};

export const NOTIFICATION_DURATION = 10;

export const MethodType = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
};

export const MCPAppCompletionStatus = {
    APP_ASSIGNED: { key: 'Assigned', label: 'APP ASSIGNED' },
    APP_ALL_COMPLETE: { key: 'Completed', label: 'APP ALL COMPLETE' },
};

export const MLPipelineAllowRoles = ['admin', 'research admin', 'reviewer', 'researcher'];
